module.exports = __webpack_public_path__ + "img/500.c983ef3c.jpg";